import { OverlayEventDetail } from "@ionic/core";
import { useRef, useState } from "react";
import Cards from "../Cards/Cards";
import BasicPage from "../baseComponents/basicPage/BasicPage";
import AddPost from "./AddPost";
import "./Feed.css";

interface ContainerProps {}

const Feed: React.FC<ContainerProps> = () => {
  const modal = useRef<HTMLIonModalElement>(null);
  const input = useRef<HTMLIonInputElement>(null);

  const [message, setMessage] = useState(
    "This modal example uses triggers to automatically open a modal when the button is clicked."
  );

  function confirm() {
    modal.current?.dismiss(input.current?.value, "confirm");
  }

  function onWillDismiss(ev: CustomEvent<OverlayEventDetail>) {
    if (ev.detail.role === "confirm") {
      setMessage(`Hello, ${ev.detail.data}!`);
    }
  }
  return (
    <>
      <BasicPage
        pathReturn="lol"
        pathLogo=""
        title="Mur Social"
        subtitle="Poste tes créations"
      >
        <AddPost />
        <Cards endpoint="feed" state="feed" />
      </BasicPage>
    </>
  );
};

export default Feed;
